<template>
  <section class="section">
    <div class="page-header no-margin">
      <h3 class="page-title">Overview</h3>
    </div>

    <div class="columns is-mobile is-multiline overview">
      <div class="column is-2-widthscreen is-3-desktop is-4-tablet is-6-mobile">
        <div class="box">
          <span class="primary"><i class="fad fa-suitcase"></i></span>

          <label>Opening Job</label>

          <div class="stat">
            <p>{{ jobs.getOverView.opening }}</p>
          </div>
        </div>
      </div>

      <div class="column is-2-widthscreen is-3-desktop is-4-tablet is-6-mobile">
        <div class="box">
          <span class="sub">
            <i class="fad fa-building"></i>
          </span>

          <label>Hiring Employer</label>

          <div class="stat">
            <p>{{ jobs.getOverView.hiringEmp }}</p>
          </div>
        </div>
      </div>

      <div class="column is-2-widthscreen is-3-desktop is-4-tablet is-6-mobile">
        <div class="box">
          <span class="info">
            <i class="fad fa-suitcase"></i>
          </span>

          <label>Approved CV</label>

          <div class="stat">
            <p>{{ jobs.getOverView.totalCVApproved }}</p>

            <p class="small-tag">
              {{ jobs.getOverView.newGradApprove }}
              <label>No Exp.</label>
            </p>
          </div>
        </div>
      </div>

      <div class="column is-2-widthscreen is-3-desktop is-4-tablet is-6-mobile">
        <div class="box">
          <span class="alert">
            <i class="fad fa-suitcase"></i>
          </span>

          <label>Pending CV</label>

          <div class="stat">
            <p>{{ jobs.getOverView.totalCVPending }}</p>

            <p class="small-tag">
              {{ jobs.getOverView.newGradPending }}
              <label>No Exp.</label>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="columns is-mobile is-multiline">
      <div class="column is-3">
        <div class="box ranking">
          <label>
            <span><i class="fal fa-trophy"></i></span>
            Top 10 Saved Job
          </label>

          <ul class="rank-list">
            <li v-for="(i, index) in jobs.getSave" :key="index">
              <span>{{ index + 1 }}</span>

              <span>{{ i.title }}</span>

              <span>{{ i.isSave }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="column is-3">
        <div class="box ranking">
          <label>
            <span><i class="fal fa-trophy"></i></span>
            Top 10 Apply Job
          </label>

          <ul class="rank-list">
            <li v-for="(i, index) in jobs.applyJob" :key="index">
              <span>{{ index + 1 }}</span>

              <span>{{ i.title }}</span>

              <span>{{ i.applyStatistics }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="column is-3">
        <div class="box ranking">
          <label>
            <span><i class="fal fa-trophy"></i></span>
            Top 10 View Job
          </label>

          <ul class="rank-list">
            <li v-for="(i, index) in jobs.viewJob" :key="index">
              <span>{{ index + 1 }}</span>

              <span>{{ i.title }}</span>

              <span>{{ i.isClick }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="column is-3">
        <div class="box ranking">
          <label>
            <span><i class="fal fa-trophy"></i></span>
            Top 10 Share Job
          </label>

          <ul class="rank-list">
            <li v-for="(i, index) in jobs.shareJob" :key="index">
              <span>{{ index + 1 }}</span>

              <span>{{ i.title }}</span>

              <span>{{ i.isShare }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { GET_OVERVIEW } from "@/graphql/overView/query";
import { apolloClient } from "../services/apollo-client";
export default {
  data: () => ({
    jobs: {
      getOverView: [],
      getSave: [],
      applyJob: [],
      viewJob: [],
      shareJob: [],
    },
  }),
  methods: {
    async queryOverView() {
      const res = await apolloClient.query({
        query: GET_OVERVIEW,
        variables: {
          dateOne: "",
          datetwo: "",
        },
      });
      this.jobs.getOverView = res.data.overView;
      this.jobs.getSave = res.data.overView.saveJob;
      this.jobs.applyJob = res.data.overView.applyJob;
      this.jobs.viewJob = res.data.overView.viewJob;
      this.jobs.shareJob = res.data.overView.shareJob;
    },
  },
  created() {
    this.queryOverView();
  },
};
</script>

<style lang="scss" scoped>
.overview {
  margin-top: 20px;
  .box {
    box-shadow: none;
    border: 1px solid var(--border-color);
    box-shadow: 0 20.215px 60.644px rgba(16, 30, 54, 0.05);
    transition: 0.2s;
    &:hover {
      box-shadow: 0px 10px 60.644px rgba(16, 30, 54, 0.2);
    }
    span {
      font-weight: 700;
      color: #000;
      width: 50px;
      height: 50px;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      &.primary {
        background-color: var(--primary-color);
      }
      &.sub {
        background-color: var(--sub-color);
      }
      &.info {
        background-color: var(--info-color);
      }
      &.alert {
        background-color: var(--alert-color);
      }
      i {
        color: #fff;
      }
    }
    label {
      margin-top: 10px;
      margin-bottom: 0;
      font-weight: 500;
      font-size: var(--sm-font);
      color: var(--dark-grey-color);
    }
    .stat {
      position: relative;
      display: flex;
      align-items: center;
      p {
        font-size: var(--xlg-font);
        line-height: 1.3;
        font-weight: 700;
        color: #000;
        position: relative;
        display: inline-block;
        margin-bottom: 0;
      }
      .small-tag {
        display: flex;
        align-items: center;
        font-size: var(--md-font);
        font-weight: 700;
        background-color: rgba(var(--sub-color), 0.13);
        padding: 5px 10px;
        margin-left: 10px;
        border-radius: 5px;
        color: var(--primary-color);
        label {
          white-space: pre;
          margin: 0 0 0 5px;
          font-weight: 500;
          color: var(--primary-color);
          font-size: var(--md-font);
        }
      }
    }
  }
}

label {
  display: block;
  font-weight: 700;
  font-size: var(--md-font);
  color: #000;
  margin-bottom: 20px;
}
.ranking {
  border: 1px solid var(--border-color);
  box-shadow: 0 20.215px 60.644px rgba(16, 30, 54, 0.05);
  transition: 0.2s;
  &:hover {
    box-shadow: 0px 10px 60.644px rgba(16, 30, 54, 0.2);
  }
  label {
    display: flex;
    align-items: center;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
      width: 30px;
      height: 30px;
      background-color: var(--alert-color);
      margin-right: 10px;
      i {
        font-size: var(--md-font);
        color: #fff;
      }
    }
  }
  .rank-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
    li {
      display: flex;
      padding: 8px 0;
      span {
        font-size: var(--sm-font);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        text-align: left;
        &:first-child {
          max-width: 25px;
          width: 100%;
          color: #000;
        }
        &:last-child {
          flex-grow: 1;
          max-width: 50px;
          width: 100%;
          margin-left: auto;
          text-align: right;
          color: var(--primary-color);
          font-weight: 700;
        }
      }
    }
  }
}
</style>
